import { useContext, useEffect } from "react";
import { useNavigate } from "react-router";

import {
  isAdminUser,
  isDemographicsManagerUser,
  isManagerUser,
  isMcaUserSession,
  isNHSDashboardViewerUser,
  isPaymentReviewerSession,
  isSupersetDashboardViewerUser,
  isTeamManagerUser,
} from "@thalamos/aspire-common";

import { LoggedInUserContext } from "../Contexts.js";
import { AdminPage } from "./Admin/AdminPage.js";
import { CaseloadPage } from "./Caseload/Caseload.js";
import { DashboardLandingPage } from "./dashboard/DashboardLandingPage.js";
import { DashboardPage } from "./DashboardPage.js";
import type { DefaultPageProps } from "./defaultProps.js";
import { DemographicsManagerHomePage } from "./DemographicsManagerPage/DemographicsManagerPage.js";
import { TeamsOverviewPage } from "./ExternalAdmin/Teams/TeamsOverviewPage.js";
import { NHSDashboardPage } from "./nhsDashboardPage/nhsDashboardPage.js";
import { routeFns } from "~/routePaths.js";

export function HomePage(props: DefaultPageProps) {
  const userContext = useContext(LoggedInUserContext);
  const user = userContext?.user!;
  const navigate = useNavigate();

  const isTeamManager = isTeamManagerUser(user);
  const isPaymentReviewer = isPaymentReviewerSession(user);
  const isMcaUser = isMcaUserSession(user);
  const userSessionTeamId = user?.sessionContext?.teamId;

  useEffect(() => {
    if (isMcaUser) {
      navigate(routeFns.careHomeRegister());
    } else if (isPaymentReviewer) {
      navigate(routeFns.paymentReviewerPage());
    } else if (isTeamManager && userSessionTeamId) {
      navigate(routeFns.managerTeamEdit(userSessionTeamId));
    }
  }, [userContext]);

  // We should have a user and a user context by this point
  if (!userContext?.user?.sessionContext) {
    return <div>Loading...</div>;
  }

  const isCurrentUserManager = isManagerUser(user);

  return isAdminUser(user) ? (
    <AdminPage {...props} />
  ) : isDemographicsManagerUser(user) ? (
    <DemographicsManagerHomePage {...props} />
  ) : isCurrentUserManager ? (
    <TeamsOverviewPage {...props} />
  ) : userContext?.user?.sessionContext?.type === "team" ? (
    <CaseloadPage {...props} />
  ) : isNHSDashboardViewerUser(user) ? (
    <NHSDashboardPage {...props} />
  ) : isSupersetDashboardViewerUser(user) ? (
    <DashboardLandingPage />
  ) : (
    <DashboardPage {...props} />
  );
}
